import { constants } from '../../App.constants'

import axios from 'axios';

export const embeddedUrl = (clientUserId, templateId, signerData, prefillData, returnUrl, cb) => {
    return async (dispatch) => {
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'x-user-id': clientUserId
            }
        }

        const data = {
            templateId: templateId,
            signer1: signerData,
            prefill: prefillData,
            returnUrl: returnUrl
        }

        try {
            const payload = await axios.post(constants.dashboardBaseUrl + '/oauth/docusign/embedded-url', data,  headers)
            cb(payload.data.error, payload)
        } catch (error) {
            cb('error')
        }
        

    }
}